export default function ImageRow({ images }) {
  return (
    <div style={{ display: "flex", width: "100%" }}>
      {images.map((img) => {
        const Wrapper = img.link ? "a" : "div";

        return (
          <Wrapper
            key={img.imgId}
            {...(img.link
              ? {
                  href: img.link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                }
              : {})}
            style={{ flex: 1 }}
          >
            <img
              src={img.image}
              style={{
                width: "100%",
                display: "block",
              }}
              alt=""
            />
          </Wrapper>
        );
      })}
    </div>
  );
}
